var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconBuilding(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_19_1127)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.66667 15.1667H8.16667V17.5H4.66667V15.1667ZM10.5 17.5H14V15.1667H10.5V17.5ZM4.66667 22.1667H8.16667V19.8333H4.66667V22.1667ZM10.5 22.1667H14V19.8333H10.5V22.1667ZM4.66667 8.16667H8.16667V5.83333H4.66667V8.16667ZM10.5 8.16667H14V5.83333H10.5V8.16667ZM4.66667 12.8333H8.16667V10.5H4.66667V12.8333ZM10.5 12.8333H14V10.5H10.5V12.8333ZM28 9.33333V28H0V3.5C0 2.57174 0.368749 1.6815 1.02513 1.02513C1.6815 0.368749 2.57174 0 3.5 0L15.1667 0C16.0949 0 16.9852 0.368749 17.6415 1.02513C18.2979 1.6815 18.6667 2.57174 18.6667 3.5V5.83333H24.5C25.4283 5.83333 26.3185 6.20208 26.9749 6.85846C27.6313 7.51484 28 8.40508 28 9.33333ZM16.3333 3.5C16.3333 3.19058 16.2104 2.89383 15.9916 2.67504C15.7728 2.45625 15.4761 2.33333 15.1667 2.33333H3.5C3.19058 2.33333 2.89383 2.45625 2.67504 2.67504C2.45625 2.89383 2.33333 3.19058 2.33333 3.5V25.6667H16.3333V3.5ZM25.6667 9.33333C25.6667 9.02391 25.5438 8.72717 25.325 8.50838C25.1062 8.28958 24.8094 8.16667 24.5 8.16667H18.6667V25.6667H25.6667V9.33333ZM21 17.5H23.3333V15.1667H21V17.5ZM21 22.1667H23.3333V19.8333H21V22.1667ZM21 12.8333H23.3333V10.5H21V12.8333Z",
    fill: "#4AC6FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_19_1127"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBuilding);
export default __webpack_public_path__ + "static/media/icon_building.9c4084268e69b0267963c7cd716bfecd.svg";
export { ForwardRef as ReactComponent };